import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "../components/ui/button";
import { buildPropertyShareText, whatsappLink } from "../lib/brand";

export default function WhatsAppShareButton({ property, size = "sm", variant = "outline", label = "Share on WhatsApp", testid }) {
  const handle = (e) => {
    e.preventDefault();
    e.stopPropagation();
    // v2.73 — CRITICAL share-preview fix: share the SSR OG endpoint, NOT the
    // SPA route. WhatsApp's crawler can't run JS — `/property/<id>` returns
    // the static index.html whose GLOBAL og tags made every property render
    // the SAME generic card (same title/image for unrelated listings).
    // `/api/share/property/<id>` is server-rendered with THIS property's
    // title/price/photo and meta-refreshes humans to the real page.
    const link = `${window.location.origin}/api/share/property/${property.id}`;
    const text = buildPropertyShareText(property, link);
    window.open(whatsappLink(text), "_blank", "noopener,noreferrer");
  };
  return (
    <Button
      type="button"
      size={size}
      variant={variant}
      onClick={handle}
      data-testid={testid || `wa-share-${property.id}`}
      className="rounded-sm border-[#16A34A] text-[#16A34A] hover:bg-[#16A34A] hover:text-white transition-colors"
    >
      <MessageCircle size={14} className="mr-1.5" /> {label}
    </Button>
  );
}
